import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ui/ScrollToTop";

// Layout
import { Layout } from "@/components/layout/Layout";

// Pages
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import FarmStoriesPage from "@/pages/FarmStoriesPage";
import FarmDetailPage from "@/pages/FarmDetailPage";
import SustainabilityPage from "@/pages/SustainabilityPage";
import AboutPage from "@/pages/AboutPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop/>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:productId" element={<ProductDetailPage />} />
            <Route path="/farm-stories" element={<FarmStoriesPage />} />
            <Route path="/farm-stories/:farmId" element={<FarmDetailPage />} />
            <Route path="/sustainability" element={<SustainabilityPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
